import React from 'react';
import { cn } from '../../lib/classNames';

const variants = {
  default: 'bg-muted text-muted-foreground',
  primary: 'bg-primary-muted text-primary',
  info: 'bg-info/10 text-info',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  danger: 'bg-destructive/10 text-destructive'
};

export const Badge = ({ variant = 'default', className, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium',
      variants[variant] || variants.default,
      className
    )}
    {...props}
  />
);
